import { Injectable } from '@angular/core';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


@Injectable({
  providedIn: 'root',
})

export class UserService {

  assabil : boolean = true;
  
  isRoot      : boolean;
  userInfo    : UserInfo;
  selectedMenu: any;


  //rolesLov    : Role[] = [];
 


  userMenuGrant(id : string){
    if (! id) return true;
    if (! this.userInfo.menus) return false;
    if (this.userInfo.menus.indexOf('assabil') >= 0) return true;
    if (this.userInfo.menus.indexOf(id) >= 0) return true;

    let i = id.indexOf("-");

    if (i < 0){
      if (this.userInfo.menus.indexOf(id+'-%') >= 0) return true;
    }

    while (i > 0) {
      let prefix = id.substr(0, i+1);
    //  console.log(" i = " + i + "               prefix = " + prefix);
      if (this.userInfo.menus.indexOf(prefix+'%') >= 0) return true;
      i = id.indexOf("-", i+1);      
    }
    return false;
  }
  
  userServiceGrant(id : string){
    if (! this.userInfo.services) return false;
    if (this.userInfo.services.indexOf('assabil') >= 0) return true;
    if (this.userInfo.services.indexOf(id) >= 0) return true;

    let i = id.indexOf("-");

    if (i < 0){
      if (this.userInfo.services.indexOf(id+'-%') >= 0) return true;
    }

    while (i > 0) {
      let prefix = id.substr(0, i+1);
      if (this.userInfo.services.indexOf(prefix+'%') >= 0) return true;
      i = id.indexOf("-", i+1);
    }
    return false;
  }

}
